import { round } from 'lodash'

export const getStorageSize = (mb: number, postfix: { mb: string; gb: string }) => {
    const isGb = mb >= 1024

    return `${round(isGb ? mb / 1024 : mb)} ${isGb ? postfix.gb : postfix.mb}`
}
